<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">

    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">QrCode Table</h3>
            <button class="btn btn-success" (click)="initModal('create')">Create</button>
            <button class="btn btn-primary" *ngIf="listPrint.length > 0" (click)="printAll()">Print All</button>
            <button class="btn btn-danger" *ngIf="listPrint.length > 0" (click)="deleteQrCode()">Delete All</button>
          </div>
          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th><input type="checkbox" [checked]="checkedAll" #ckbAll (change)="checkAll(ckbAll)"></th>
                  <th>USED</th>
                  <th>Product ID</th>
                  <th>NO ID</th>
                  <th>QTY.</th>
                  <th>SERIAL ID</th>
                  <th>DESCRIPTION</th>
                  <th class="w-1">CREATE</th>
                  <th class="w-1">ACT.</th>
                </tr>
              </thead>
              <tbody *ngIf="!isLoading">
                <tr *ngFor="let qrcode of qrCodeList">
                  <td>
                      <input type="checkbox" [checked]="isChecked(qrcode.serialId)" #ckb1 (change)="checkChange(qrcode, ckb1)">
                  </td>
                  <td>
                      <label class="switch">
                          <input type="checkbox" [checked]="qrcode.used" #ckb (change)="setQrCodeUsed([qrcode.serialId], ckb)">
                          <span class="slider round"></span>
                        </label>
                  </td>
                  <td>
                    <span>{{ qrcode.productId }}</span>
                  </td>
                  <td>
                    <span>{{ qrcode.noId }}</span>
                  </td>
                  <td>
                    <span>{{qrcode.numberPerCode}}</span>
                  </td>
                  <td>
                    <ngx-qrcode [qrc-element-type]="'elementType'" [qrc-value]="qrcode.serialId + '-' + qrcode.noId + '-' + qrcode.hmac"></ngx-qrcode>
                    <code>{{ qrcode.formatCode }}</code>
                  </td>
                  <td>
                    <span>{{qrcode.description}}</span>
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ qrcode.createdAt | date:'hh:mm dd-MM-yyyy' }}

                  </td>
                  <td>
                    <a class="btn btn-default" (click)="printQrCode(qrcode)">
                      <i class="fa fa-qrcode" aria-hidden="true"></i>
                    </a>
                    <a class="btn btn-danger" (click)="deleteQrCode([qrcode.serialId + ''])">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="qrCodeList?.length === 0">
                  <td class="text-center" colspan="9">
                    <span>Can not found.</span>
                  </td>
                </tr>
                <tr *ngIf="qrCodeList?.length !== 0">
                  <td colspan="9">
                    Displaying {{filterParams.page * filterParams.size + 1}} - {{ (filterParams.page) * filterParams.size + qrCodeList?.length
                    }} of {{ totalElements }}
                    <ul *ngIf="filterParams.size < totalElements" class="pagination pull-right">
                      <li [class.disabled]="filterParams.page == 0" (click)="filterParams.page = filterParams.page - 1">
                        <a>
                          <span aria-hidden="true">«</span>
                          Previous</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 3" (click)="filterParams.page = 0">
                        <a>1</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 4" class="disabled hidden">
                        <a>...</a>
                      </li>
                      <li *ngFor="let number of initPaginate()" [class]="filterParams.page == number ? 'active' : class" [class.hidden]="(filterParams.page + 2 < number || filterParams.page - 2 > number)"
                        (click)="filterParams.page = number">
                        <a>{{ number + 1 }}</a>
                      </li>
                      <li [class.hidden]="filterParams.page > totalPage - 5" class="disabled">
                        <a>...</a>
                      </li>
                      <li [class.hidden]="filterParams.page >  totalPage - 4" (click)="filterParams.page = totalPage -1">
                        <a>{{ totalPage }}</a>
                      </li>
                      <li [class.disabled]="filterParams.page == totalPage - 1" (click)="filterParams.page = filterParams.page + 1">
                        <a>
                          <span aria-hidden="true">»</span>
                          Next</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>
            <p class="text-center" *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>

  </section>
</div>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <form (ngSubmit)="onSubmit(formQrCode)" #formQrCode="ngForm">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title"> {{ modal.title }}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Product Id:</label>
            <input type="text" class="form-control" name="productId" ngModel [(ngModel)]="qrCode.productId" #txtProductId="ngModel" required>
            <span *ngIf="txtProductId.errors?.required  && txtProductId.dirty" class="text text-danger">Product Id is required.</span>
          </div>

          <div class="form-group">
            <label>Number of Code: </label>
            <input type="text" class="form-control" name="numberCode" pattern="[0-9]+" ngModel [(ngModel)]="qrCode.numberCode" #txtNumber="ngModel"
              required>
            <span *ngIf="txtNumber.errors?.required  && txtNumber.dirty" class="text text-danger">Number of code is required.</span>
            <span *ngIf="txtNumber.hasError('pattern')" class="text text-danger">Please input only number.</span>
          </div>

          <div class="form-group">
            <label>Number per Code: </label>
            <input type="text" class="form-control" name="numberPerCode" pattern="[0-9]+" ngModel [(ngModel)]="qrCode.numberPerCode"
              #txtNumberPerCode="ngModel" required>
            <span *ngIf="txtNumberPerCode.errors?.required  && txtNumberPerCode.dirty" class="text text-danger">Number per code is required.</span>
            <span *ngIf="txtNumberPerCode.hasError('pattern')" class="text text-danger">Please input only number.</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" [disabled]="formQrCode.invalid" class="btn btn-primary">{{ modal.btnName }}</button>
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal -->
<div id="selectLayout" class="modal fade" role="dialog">
    <div class="modal-dialog">
  
      <!-- Modal content-->
      <div class="modal-content">
        <form >
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Select layout print</h4>
          </div>
          <div class="modal-body">
              <div class="form-group">
                  <label>Size:</label>
                  <select [(ngModel)]="sizeQrcode" name="sizeQrcode" class="form-control">
                    <option value="big">2x2(2 small - 2 big)</option>
                    <option value="small">1x4(4 small)</option>
                  </select>
                </div>
            <div class="form-group">
                <label>Layout:</label>
              <select [(ngModel)]="selectedLayout" name="selectedLayout" class="form-control">
                <option *ngFor="let layout of layoutPrintList" [value]="layout.id">{{layout.name}}</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-success" [disabled]="!selectedLayout" (click)="openWindowPrint()">Print</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>



// WEBPACK FOOTER //
// /build/client-cms/src/app/qr-code/qr-code.component.html